var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJlrWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 175.728,
    height: 154.58,
    viewBox: "0 0 175.728 154.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Jaguar_Land_Rover_JLR",
    "data-name": "Jaguar Land Rover JLR",
    transform: "translate(-144.99 -54.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6158",
    "data-name": "Path 6158",
    d: "M156.212,54.73h13.972c.105,40.445.022,80.9.022,121.342a39.238,39.238,0,0,1-17.993,33.238h-.029q-5.921-9.522-7.128-11.448a.358.358,0,0,1-.067-.162,26.1,26.1,0,0,0,9.257-11.244,27.441,27.441,0,0,0,1.951-10.161Q156.208,115.508,156.212,54.73Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6159",
    "data-name": "Path 6159",
    d: "M313.966,54.73h13.985q.033,58.5.01,117a.077.077,0,0,0,.076.076h55.875a.149.149,0,0,1,.121.067l8.341,13.539c.01.016.006.025-.016.025H314a.042.042,0,0,1-.041-.041Z",
    transform: "translate(-115.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6160",
    "data-name": "Path 6160",
    d: "M447.321,54.73h38.672c19.282.56,36.164,15.6,36.568,35.428.395,19.361-13.237,34.409-32.219,36.823a.038.038,0,0,0-.032.041c0,.006,0,.01.006.016l36.364,58.374v.029l-14.886-.006a.106.106,0,0,1-.089-.051l-36.135-57.913a.187.187,0,0,0-.162-.089q-14.192-.062-28.189-.01a.079.079,0,0,1-.08-.08h0V113.8a.057.057,0,0,1,.057-.057q19.1,0,38.195-.022a22.4,22.4,0,0,0,20.934-13.7,23.094,23.094,0,0,0-2.107-22.042,22.409,22.409,0,0,0-17.264-9.563c-.939-.054-1.878-.083-2.817-.08q-18.341.019-36.759.019a.064.064,0,0,1-.064-.064Z",
    transform: "translate(-205.963)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJlrWhite);
export default __webpack_public_path__ + "static/media/JLR_white.fffdbf3b5b196db8eb4b20670d263255.svg";
export { ForwardRef as ReactComponent };